var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconPlusInCircleWhite = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 18,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 8.5,
  cy: 9,
  r: 7.5,
  stroke: "#fff",
  strokeWidth: 1.25
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#fff",
  strokeWidth: 0.2,
  d: "M12.59 8.318H9.183v-3.41a.682.682 0 0 0-1.364 0v3.41H4.41a.682.682 0 0 0 0 1.364h3.41v3.409a.682.682 0 0 0 1.363 0V9.68h3.409a.682.682 0 0 0 0-1.363Z",
  clipRule: "evenodd"
})));
export default SvgIconPlusInCircleWhite;